import * as React from 'react';
import { useSelector } from 'react-redux';
import { selectBuilder } from '../../selectors';
import { BuilderInfo } from '../../components/BuilderInfo';
import { useApplicationContext } from '../../utils/applicationContext';
import { isReliableBuilder } from '../../utils/builder';
import { isBuilderWithEscrow } from '../../utils/builder/isBuilderWithEscrow';

export const BuilderInfoContainer = () => {
  const { config } = useApplicationContext();
  const builder = useSelector(selectBuilder);

  const { reliable, withEscrow } = React.useMemo(
    () => ({
      reliable: isReliableBuilder(builder.id, config),
      withEscrow: isBuilderWithEscrow(builder.id, config),
    }),
    [builder, config],
  );

  return <BuilderInfo {...builder} reliable={reliable} withEscrow={withEscrow} />;
};
